import { GlobalService } from './../../helper/Services/global.service';
import { ActivatedRoute } from '@angular/router';
import { OrderStatusService } from './../../Services/orderstatus/order-status.service';
import { ServiceDetails, CustomerDealerDeatail } from './invoice-details.model';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { SecureStorage } from '../../helper/Services/secure-storage';
import { themes } from '../../helper/Enums/theme.const';

@Component({
  selector: 'app-pdf-view',
  templateUrl: 'pdf-view.component.html',
  styleUrls: ['pdf-view.component.css']
})
export class PdfViewComponent implements OnInit {

  servicesDetails: ServiceDetails[] = [];
  dealerAdvices: ServiceDetails[] = [];
  imageSrc: string;
  themeLogo: string;
  currencyType:any;
  currentTheme:any;
  appTheme: string;
  // customerDealerDetails: CustomerDealerDeatail;
  customerDealerDetails: CustomerDealerDeatail = {
    CustomerId: undefined,
    CustomerName: undefined,
    CustomerAddress1: undefined,
    CustomerAddress2: undefined,
    EmailId: undefined,
    MobileNo: undefined,
    DealerName: undefined,
    DealerAddress1: undefined,
    DealerAddress2: undefined,
    DealerEmailId: undefined,
    DealerMobileNo: undefined,
    OPENINGHRS: undefined,
    Country: undefined,
    LandlineNo: undefined,
    CompanyMake: undefined,
    CompanyModel: undefined,
    LicensePlateNo: undefined,
    OrderNumber: undefined,
    OrderStatus: undefined,
    OpeningHours: '',
    DealerCity: '',
    DealerPinCode: ''
  };

  grandTotal = 0;
  @ViewChild('content') content: ElementRef;
  constructor(
    private orderStatusService: OrderStatusService,
    private route: ActivatedRoute,
    private gService: GlobalService,
    private secureStorage: SecureStorage
  ) { }
  ngOnInit() {
    const cTheme = this.secureStorage.getKeyData('cTheme');
    this.themeLogo = themes[cTheme.code].logoPath;
    this.currencyType=themes[cTheme.code].currencyType;
    this.currentTheme=cTheme.code;	
    this.appTheme = cTheme.code;
    this.orderStatusService.invoiceClicked.subscribe(x=> {
      if(x){
        this.generatePdf();
      }
    })
  }

  generatePdf() {
    this.gService.currentUser.subscribe(response => {
      this.orderStatusService.getInvoiceDetails()
        .subscribe(res => {
          this.customerDealerDetails = res.customerDealerDetails[0];
          this.servicesDetails = res.serviceDetails;
          let brandLogo = this.gService.getBrandLogo(this.customerDealerDetails.CompanyMake);
          this.imageSrc = brandLogo == undefined ?
            null : brandLogo.pngPath;
          this.calculateTotal();
          setTimeout(() => {
            let data = document.getElementById('content');
            html2canvas(data,
              { logging: false }
            ).then(canvas => {
              // Few necessary setting options
              const imgWidth = 190;
              const imgHeight = canvas.height * imgWidth / canvas.width;
              const contentDataURL = canvas.toDataURL('image/png');
              const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
              const position = 10;
              pdf.setProperties({
                title: 'Invoice',
              });

              pdf.addImage(contentDataURL, 'PNG', 10, position, imgWidth, imgHeight);
              pdf.output('bloburl');
            });
          }, 1000);
        });
    });
  }

  calculateTotal() {
    this.grandTotal = 0;
    this.servicesDetails.forEach(element => {
      this.grandTotal += +element.Price;
    });
    this.dealerAdvices.forEach(element => {
      this.grandTotal += +element.Price;
    });
  }
}
